module.exports = __webpack_public_path__ + "img/logo-help.2750e69d.png";